import type { AccountsConfig } from './type';

export const accounts: AccountsConfig = {
    multicurrency: {
        enabled: true,
    },
    accountNameMatchString: /^[0-9A-Za-z čćšđžČĆŠĐŽ.,]+$/.toString(),
    settingsDetails: {
        displayAccountRepresentatives: true,
    },
    isJuniorAliasChangeAllowed: true,
    isNativeAliasChangeAllowed: true,
    accountDetailCopyActionAvailableForType: ['CURRENT', 'SAVING', 'LOAN'],
};
